import React from "react";
import s1 from "../assets/s1.png";
import solution from "../assets/solution.png";
import solution1 from "../assets/exchange.png";
import solution2 from "../assets/neural.png";
import solution3 from "../assets/cash-withdrawal.png";
import solution4 from "../assets/files.png";
import solution5 from "../assets/shield.png";
import PhoneHeader from "./PhoneHeader";

const ATMInstallation = () => {
  return (
    <>
      <PhoneHeader title="AEPS Service" className="d-md-none d-block" />

      {/* <div className="container-fluid d-md-block d-none">
        <div className="text-center top-heading section">
          <h1>AEPS Service</h1>
        </div>
      </div> */}
      <div className="container space">
        <div className="text-center top-heading section">
          <h1 className="mb-0">ATM Installation Services </h1>
        </div>
        <div className="row section align-items-center">
          <div className="col-12 col-md-7">
            <div className="">
              <h1>
                <strong>Overview</strong>
              </h1>
            </div>
            <p>
              {/* <strong style={{ color: "#FF7A60", fontSize: "26px" }}>O</strong> */}
              Our ATM Installation Services are designed to bring convenient cash
              access to retail stores, business outlets, and financial service
              points. Whether you run an AEPS outlet, mini-bank, franchise
              store, or payment center, installing an ATM helps you increase
              customer footfall and generate additional revenue through
              transaction commissions.
            </p>
            <ul className="list-unstyled mb-4 mb-md-0">
              <h5 className="fw-bold mt-2 mb-3">Who Can Install an ATM?</h5>
              <li className="mb-2">• AEPS retailers</li>
              <li className="mb-2">• CSC operators</li>
              <li className="mb-2">• Financial service providers</li>
              <li className="mb-2">• Shopkeepers & supermarkets</li>
              <li className="mb-2">• Petrol pumps & hotels</li>
              <li className="mb-2">• Small businesses and franchises</li>
            </ul>
          </div>
          <div className="col-12 col-md-5 mb-3 mb-md-0">
            <div className="">
              <img src={s1} className="w-100 m-auto img-holl" />
            </div>
          </div>
        </div>

        <div
          className="row section p-md-4 px-1 pt-5 pb-4"
          style={{ backgroundColor: "#FFF6F3" }}
        >
          <div className="col-12 col-md-6 m-auto text-center d-none d-md-block">
            <img src={solution} alt="solution" className="img-fluid" />
          </div>

          <div className="col-12 col-md-6 m-auto">
            <h2 className="mb-md-5 mb-3 center" style={{ fontWeight: "700" }}>
              ATM Installation for AEPS Retailers
            </h2>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution1} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Increases customer footfall
                </h6>
                <p className="mb-0">
                  Customers regularly visit locations with ATM access.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution2} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Boosts earnings with passive income
                </h6>
                <p className="mb-0">
                  Each transaction adds to your monthly commission.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution3} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Enhances trust & visibility
                </h6>
                <p className="mb-0">
                  An ATM adds credibility to AEPS and digital payment service
                  centers.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution4} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Supports your AEPS business
                </h6>
                <p className="mb-0">
                  Customers who come to withdraw cash may also use AEPS, UPI
                  ATM, DMT, BBPS, and other services.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center g-4 section">
          <h2
            className="mt-md-4 mb-md-5"
            style={{ textAlign: "center", fontWeight: "600" }}
          >
            Key Features of Our ATM Installation Services
          </h2>
          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so1}
                alt="Software Development"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                Quick & Hassle-Free Installation
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start">
                We provide end-to-end setup, including machine installation,
                activation, software configuration, and support.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so2}
                alt="Hardware Support"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                {" "}
                Multiple ATM Options{" "}
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start">
                We offer a wide range of ATM options to suit your business
                needs.
              </p>
              {/* <ul className="list-unstyled">
                <li className="mb-2">• On-site ATMs</li>
                <li className="mb-2">• Off-site ATMs</li>
                <li className="mb-2">• White-label ATMs</li>
              </ul> */}
            </div>
          </div>

          {/* <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              />
              <h5 className="fw-semibold text-center">
                Secure & Compliant Machines
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start">
                All ATMs meet industry standards for:
              </p>
              <ul className="list-unstyled">
                <li className="mb-2">• Cash security</li>
                <li className="mb-2">• Encryption technology</li>
                <li className="mb-2">• Fraud protection</li>
                <li className="mb-2">• CCTV and alarm integration</li>
              </ul>
            </div>
          </div> */}

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so1}
                alt="Software Development"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                {" "}
                Real-Time Monitoring & Support
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start">
                We offer ongoing technical support, monitoring, and maintenance
                to ensure smooth and continuous ATM operation.
              </p>
            </div>
          </div>

          {/* <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              <img
                src={so2}
                alt="Hardware Support"
                className="mb-3 img-fluid"
              />
              <h5 className="fw-semibold text-center">
                Additional Commission Income
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start">
                Earn attractive commissions from:
              </p>
              <ul className="list-unstyled">
                <li className="mb-2">• Every cash withdrawal</li>
                <li className="mb-2">• Balance inquiry</li>
                <li className="mb-2">• Mini statements</li>
              </ul>
            </div>
          </div> */}

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                DTH Recharge & Bill Payment
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start">
                Recharge or pay monthly bills for all major DTH operators
                quickly and securely.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                Insurance Premium Payment
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start">
                Pay life and general insurance premiums on time through trusted
                BBPS channels.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">Loan EMI Payment</h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start">
                Convenient repayment of loan EMIs for supported banks and NBFCs.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                Municipal & Other Utility Bills
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start">
                Pay municipal taxes and other approved utility bills available
                on BBPS.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ATMInstallation;
